import { marked } from "marked";

export function renderText(testoHTML) {
  if (!testoHTML) return "";
  const strippedText = testoHTML.replace(/<[^>]*>/g, "");
  const truncatedText =
    strippedText.length > 230
      ? strippedText.substring(0, 230) + "..."
      : strippedText;
  return <div>{truncatedText}</div>;
}

export const formatTextToHTML = (text) => {
  // Pre-processa il testo per convertirlo in markdown valido
  const processedText = text
    // Converte \n in veri a capo
    .replace(/\\n/g, "\n")
    // Rimuove caratteri problematici come :-*
    .replace(/:-\*/g, " ")
    // Assicurati che ci siano linee vuote prima dei titoli
    .replace(/\n(#{1,6}\s)/g, "\n\n$1")
    // Assicurati che ci siano linee vuote dopo i separatori
    .replace(/---\n/g, "---\n\n");

  // Configura marked per supportare tabelle e altre funzionalità
  marked.setOptions({
    gfm: true, // GitHub Flavored Markdown
    breaks: true, // Converte \n in <br>
    tables: true,
    sanitize: false,
  });

  // Converti markdown in HTML
  return marked(processedText);
};
